/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { StreamAnalysisGetVideoAnalysisStationSettingsQueryResponse, StreamAnalysisGetVideoAnalysisStationSettingsPathParams, StreamAnalysisGetVideoAnalysisStationSettings401, StreamAnalysisGetVideoAnalysisStationSettings403 } from "../models/StreamAnalysisGetVideoAnalysisStationSettings";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { streamAnalysisGetVideoAnalysisStationSettings } from "../axios/streamAnalysisGetVideoAnalysisStationSettings";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const streamAnalysisGetVideoAnalysisStationSettingsQueryKey = (entityId: StreamAnalysisGetVideoAnalysisStationSettingsPathParams["entityId"]) => ["api-v2", { url: '/stream-analysis/v1/video-analysis/station-settings/:entityId', params: {entityId:entityId} }] as const

export type StreamAnalysisGetVideoAnalysisStationSettingsQueryKey = ReturnType<typeof streamAnalysisGetVideoAnalysisStationSettingsQueryKey>

export function streamAnalysisGetVideoAnalysisStationSettingsQueryOptions(entityId: StreamAnalysisGetVideoAnalysisStationSettingsPathParams["entityId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = streamAnalysisGetVideoAnalysisStationSettingsQueryKey(entityId)
        return queryOptions<StreamAnalysisGetVideoAnalysisStationSettingsQueryResponse, ResponseErrorConfig<StreamAnalysisGetVideoAnalysisStationSettings401 | StreamAnalysisGetVideoAnalysisStationSettings403>, StreamAnalysisGetVideoAnalysisStationSettingsQueryResponse, typeof queryKey>({
         enabled: !!(entityId),
         queryKey,
         queryFn: async ({ signal }) => {
            return streamAnalysisGetVideoAnalysisStationSettings(entityId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Every setting is resolved to its effective value, taking the station's own value when present, then the inherited value, then the built-in default. Only settings available to API clients are included.
 * @summary Get the effective settings of a station
 * {@link /stream-analysis/v1/video-analysis/station-settings/:entityId}
 */
export function useStreamAnalysisGetVideoAnalysisStationSettings<TData = StreamAnalysisGetVideoAnalysisStationSettingsQueryResponse, TQueryData = StreamAnalysisGetVideoAnalysisStationSettingsQueryResponse, TQueryKey extends QueryKey = StreamAnalysisGetVideoAnalysisStationSettingsQueryKey>(entityId: StreamAnalysisGetVideoAnalysisStationSettingsPathParams["entityId"], options: 
{
  query?: Partial<QueryObserverOptions<StreamAnalysisGetVideoAnalysisStationSettingsQueryResponse, ResponseErrorConfig<StreamAnalysisGetVideoAnalysisStationSettings401 | StreamAnalysisGetVideoAnalysisStationSettings403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? streamAnalysisGetVideoAnalysisStationSettingsQueryKey(entityId)
         

         const query = useQuery({
          ...streamAnalysisGetVideoAnalysisStationSettingsQueryOptions(entityId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<StreamAnalysisGetVideoAnalysisStationSettings401 | StreamAnalysisGetVideoAnalysisStationSettings403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}